import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CurrencyLayer from "../components/CurrencyLayer";

const CurrencyPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Currencies">

        {/* CurrencyLayer */}
        <CurrencyLayer />
      </MasterLayout>
    </>
  );
};

export default CurrencyPage;
